import "./CataloguePage.scss";
// REACT, ROUTER & REDUX
import React from "react";
import { Link } from "react-router-dom";

// SVG & IMAGES
import catalogueHeaderFigure from "../img/header-catalogue.svg";

/*
CATALOGUE PAGE COMPONENT INFORMATION
  When clicking on any link, the URL will change. Forcing the MAIN component to load the catalogue data into the CATALOGUEUNIT component and displaying it to us.
*/

export default function CataloguePage() {
  // ::::: JSX ::::::
  return (
    <div className="catalogue-page">
      <header>
        <figure>
          <img src={catalogueHeaderFigure} alt="calc-header-figure" />
        </figure>
        <h1>catalogue</h1>
      </header>
      <section className="catalogue-page__links">
        <Link
          to="pipeData"
          className="catalogue-page__link rectangular-button inverse-color translateY"
        >
          <h4>pipes</h4>
        </Link>
        <Link
          to="waterData"
          className="catalogue-page__link rectangular-button inverse-color translateY"
        >
          <h4>water & steam</h4>
        </Link>
        <Link
          to="thermalData"
          className="catalogue-page__link rectangular-button inverse-color translateY"
        >
          <h4>Thermal</h4>
        </Link>
        <Link
          to="gdntData"
          className="catalogue-page__link rectangular-button inverse-color translateY"
        >
          <h4>GD&T</h4>
        </Link>
        <Link
          to="unitsData"
          className="catalogue-page__link rectangular-button inverse-color translateY"
        >
          <h4>SI-units</h4>
        </Link>
        <Link
          to="frictionData"
          className="catalogue-page__link rectangular-button inverse-color translateY"
        >
          <h4>Friction</h4>
        </Link>
        <Link
          to="screwData"
          className="catalogue-page__link rectangular-button inverse-color translateY"
        >
          <h4>Screws</h4>
        </Link>
      </section>
    </div>
  );
}
